import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC, ReactElement } from 'react';

interface StatusTagProps {
  label: string;
  value?: boolean;
  icon?: ReactElement;
}

const StatusTag: FC<StatusTagProps> = ({ value, label, icon }) => {
  const { t } = useTranslation();

  const defaultIcon = value ? (
    <CheckCircleFilled className={s.iconCheck} />
  ) : (
    <CloseCircleFilled className={s.iconClose} />
  );

  const customIcon = icon ? (
    <span className={value ? s.iconCheck : s.iconGray}>{icon}</span>
  ) : null;

  return (
    <div className={classNames(s.wrapper, { [s.active]: value })}>
      {customIcon ?? defaultIcon}
      <div className={s.text}>
        <p className={s.label}>{label}</p>
        <span>-</span>
        <span className={s.flag}>
          {value ? t('controls.yes') : t('controls.no')}
        </span>
      </div>
    </div>
  );
};
export default StatusTag;
